import React, {useState} from 'react';
import { useHistory } from 'react-router';
import './coursecard.css';



function CourseCard({courseImg, icon, age, price, title, duration, location, description, prequisite, currency, fullDesc})
 {
    const [open, setOpen] = useState(false)
    const history = useHistory();
  
const enroll = () => {
    
    history.push('enrollment')
}
const learn = () => {
    history.push('contact')
}


const openModal = () => {
    setOpen(!open)
}


    return (
        <>
        <div data-aos='zoom-in' className="course__card">
            <div className="courseCard__body">
                <div className="courseCard__top">
                    <div className="courseCard__img">
                        <img src={courseImg} alt="" />
                    </div>
                    <div className="courseCard__topDesc">
                        <div className="courseCard__age">
                            <img src={icon} alt="" />
                            <p> Age {age}</p>
                        </div>
                        <div className="courseCard__price">
                            <h3> {currency}{price}</h3>
                        </div>
                    </div>
                </div>
                <div className="courseCard__desc">
                    <div className="courseCard__title">
                        <h2>{title}</h2>
                        <p className='desc'>Duration: <span> {duration} </span></p>
                        <p className='desc'>Location: : <span> {location}</span></p>
                        <p className='desc'>Prequisite: <span> {prequisite}</span></p>
                        <p className='desc'>Course Description</p>
                        <p className='span'> {description} </p>

                    </div>
                </div>
                <div className="courseCard__buttons">
                    <button className="sec__btn" onClick={enroll}>
                        Enroll
                    </button>
                    <button className="pri__btn" onClick={openModal}>
                        Learn More
                    </button>
                </div>
            </div>
        </div>
        { open ?
        <div className="popup"  onClick={openModal}>
            <div className="popup__body">
                <div className="courseCard__top">
                    <div className="courseCard__img">
                        <img src={courseImg} alt="" />
                    </div>
                    <div className="courseCard__topDesc">
                        <div className="courseCard__age">
                            <img src={icon} alt="" />
                            <p> Age {age}</p>
                        </div>
                        <div className="courseCard__price">
                            <h3> {currency}{price}</h3>
                        </div>
                    </div>
                </div>
                <div className="pop__container">

                    <h2>{title}</h2>
                    <p className='span'> {fullDesc} </p>
                    <button className="pri__btn" onClick={openModal}>
                        Close
                    </button>
                </div>

            </div>
        </div>
        :
        ''
 }
        </>
    )
}

export default CourseCard